/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Error_Rate_LimitInputs */

const en_try_magic_error_rate_limit = /** @type {(inputs: Try_Magic_Error_Rate_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate limit exceeded, please try again later`)
};

const es_try_magic_error_rate_limit = /** @type {(inputs: Try_Magic_Error_Rate_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite de solicitudes excedido, inténtalo más tarde`)
};

/**
* | output |
* | --- |
* | "Rate limit exceeded, please try again later" |
*
* @param {Try_Magic_Error_Rate_LimitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_error_rate_limit = /** @type {((inputs?: Try_Magic_Error_Rate_LimitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Error_Rate_LimitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_error_rate_limit(inputs)
	return en_try_magic_error_rate_limit(inputs)
});